import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06abbcbf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "listView" }
const _hoisted_2 = { class: "listViewBg" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content_box" }
const _hoisted_5 = { class: "list_container" }
const _hoisted_6 = { class: "px-3 breadcrumb_list" }
const _hoisted_7 = { class: "menu_box" }
const _hoisted_8 = { class: "menu_left" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "menu_right" }
const _hoisted_12 = { class: "right_tit" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "d-flex w-100 justify-content-between" }
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 1,
  class: "article_box menu_right"
}
const _hoisted_19 = { class: "article_tit" }
const _hoisted_20 = { class: "article_date" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_content" }, null, -1))
const _hoisted_22 = { class: "article_con" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"2em"} }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_24 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.bgUrl,
        alt: ""
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_breadcrumb, { separator: ">" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("首页")
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routerPath, (item, index) => {
                return (_openBlock(), _createBlock(_component_a_breadcrumb_item, { key: index }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                span: 6,
                xl: 6,
                xs: 24
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leftMenu, (item, index) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: index,
                        class: _normalizeClass(`${_ctx.currentMenu === index ? 'left_item activeitem' : 'left_item'
                  }`),
                        onClick: ($event: any) => (_ctx.changeMenu(index))
                      }, _toDisplayString(item.categoryName), 11, _hoisted_9))
                    }), 128))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                span: 2,
                xl: 2,
                xs: 0
              }),
              _createVNode(_component_a_col, {
                span: 16,
                xl: 16,
                xs: 24
              }, {
                default: _withCtx(() => [
                  (!_ctx.isShowArticle)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.leftMenu[_ctx.currentMenu].categoryName), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rightMenu, (item, index) => {
                            return (_openBlock(), _createElementBlock("a", {
                              class: "right_item",
                              key: index,
                              onClick: ($event: any) => (_ctx.toArticle(item.id))
                            }, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("p", _hoisted_15, _toDisplayString(item.title), 1),
                                _createElementVNode("small", null, _toDisplayString(item.updateDate), 1)
                              ])
                            ], 8, _hoisted_13))
                          }), 128)),
                          (!_ctx.rightMenu.length)
                            ? (_openBlock(), _createBlock(_component_a_empty, {
                                key: 0,
                                description: "暂无数据"
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_a_pagination, {
                            current: _ctx.currentPage,
                            "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
                            pageSize: _ctx.pageSize,
                            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageSize) = $event)),
                            total: _ctx.total,
                            class: "mt-4 mb-3",
                            onChange: _ctx.handleChangePage
                          }, null, 8, ["current", "pageSize", "total", "onChange"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (Object.keys(_ctx.articleObj).length === 0)
                          ? (_openBlock(), _createBlock(_component_a_empty, {
                              key: 0,
                              description: "暂无文章",
                              class: "menu_right"
                            }))
                          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.articleObj.article?.title), 1),
                              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.articleObj.article?.updateDate), 1),
                              _hoisted_21,
                              _createElementVNode("div", _hoisted_22, [
                                _hoisted_23,
                                _createElementVNode("p", {
                                  class: "article_text",
                                  innerHTML: _ctx.articleObj.article?.articleData?.content
                                }, null, 8, _hoisted_24)
                              ])
                            ]))
                      ]))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}